<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="70%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="btnGroup">
        <el-button :type="step == 0 ? 'primary' : 'info'" @click="stepTap(0)"
          >基本信息
        </el-button>
        <el-button :type="step == 1 ? 'primary' : 'info'" @click="stepTap(1)"
          >证书信息
        </el-button>
        <el-button :type="step == 2 ? 'primary' : 'info'" @click="stepTap(2)"
          >培训记录
        </el-button>
        <el-button :type="step == 3 ? 'primary' : 'info'" @click="stepTap(3)"
          >积分信息
        </el-button>
      </div>
      <div class="dialog_content" v-if="step == '0'">
        <el-form
          label-position="left"
          label-width="150px"
          ref="formDataRef"
          :model="formData"
          :rules="formDataRules"
        >
          <el-row>
            <el-col :span="11">
              <el-form-item label="姓名：" prop="personName">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.personName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号：" prop="personIdentity">
                <el-input
                  :disabled="openData.title == '详情'"
                  @input="idCard"
                  :maxlength="18"
                  v-model="formData.personIdentity"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别：" prop="personSex">
                <el-select
                  :disabled="openData.title == '详情'"
                  v-model="formData.personSex"
                  placeholder="根据您输入的身份证号获取"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in sexOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="1">
              <el-form-item label="上传图片" prop="personPhoto" align="left">
                <el-upload
                  :action="baseUrl"
                  :disabled="openData.title == '详情'"
                  :show-file-list="false"
                  :on-success="
                    (file, fileList) => {
                      handleAvatarSuccess(file, fileList, 'add')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <div>
                    <div class="avatar" v-if="formData.personPhoto != ''">
                      <img
                        :src="
                          formData.personPhoto == '../../assets/img/user.png'
                            ? ''
                            : formData.personPhoto
                        "
                      />
                    </div>
                    <i
                      v-else
                      class="el-icon-plus avatar_uploader avatar-uploader-icon"
                    ></i>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="年龄：" prop="personAge">
                <el-input
                  :disabled="openData.title == '详情'"
                  :maxlength="3"
                  v-model.number="formData.personAge"
                  placeholder="根据您输入的身份证号获取"
                ></el-input>
              </el-form-item>

              <el-form-item label="机构点：" prop="serviceStationName">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.serviceStationName"
                  placeholder="请输入机构点"
                >
                  <el-button
                    slot="append"
                    :disabled="openData.title == '查看'"
                    icon="el-icon-search"
                    @click="lookRY"
                    style="margin-left: -15px"
                  ></el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="家政经验：" prop="familyExperience">
                <el-select
                  v-model="formData.familyExperience"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="openData.title == '详情'"
                >
                  <el-option label="有" value="0"></el-option>
                  <el-option label="无" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="手机号码：" prop="personPhone">
                <el-input
                  :disabled="openData.title == '详情'"
                  :maxlength="11"
                  v-model.number="formData.personPhone"
                  placeholder="手机号码"
                ></el-input>
              </el-form-item>
              <el-form-item label="职位：" prop="position">
                <el-select
                  :disabled="openData.title == '详情'"
                  v-model="formData.position"
                  placeholder="请选择职位"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in jobOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="区域名称：" prop="dataId">
                <el-cascader
                  ref="orgId"
                  :disabled="openData.title == '详情'"
                  :show-all-levels="false"
                  v-model="formData.dataId"
                  style="width: 100%"
                  :options="quyuList"
                  :props="{
                    checkStrictly: true,
                    emitPath: false,
                    label: 'label',
                    value: 'orgId',
                  }"
                  clearable
                >
                </el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="服务地址：" prop="address">
            <el-input
              v-model.trim="formData.address"
              :disabled="openData.title == '详情'"
            ></el-input>
            <el-button
              type="success"
              class="button"
              size="mmedium"
              style="margin-bottom: 25px; margin-top: 10px"
              @click="mapTap"
              >显示位置
            </el-button>
          </el-form-item>
          <el-form-item label="是否工作人员：" prop="isWork">
            <el-radio-group
              :disabled="openData.title == '详情'"
              v-model="formData.isWork"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog_content" v-if="step == '1'">
        <el-button
          type="success"
          class="button"
          size="medium"
          @click="addInfo('新增', 'add')"
          >新增
        </el-button>
        <div class="box">
          <el-table
            :data="oneData"
            tooltip-effect="dark"
            style="width: 100%; margin: 15px 0"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="certificateType"
              label="证书类型"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="certificateName"
              label="证书名称"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="certificateCode"
              label="证书编码"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <span class="spanBtn" @click="addInfo('查看', scope.row)"
                  >查看</span
                >
                <span
                  v-if="openData.title != '详情'"
                  class="spanBtn"
                  @click="addInfo('编辑', scope.row)"
                  >编辑</span
                >
                <span
                  v-if="openData.title != '详情'"
                  class="spanBtn"
                  @click="delInfo(scope.row, scope.$index)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            align="center"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageOne.pageSize"
            :current-page.sync="pageOne.pageNo"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageOne.total"
            @size-change="handleOneSize"
            @current-change="handleOneChange"
          ></el-pagination>
        </div>
      </div>
      <div class="dialog_content" v-if="step == '2'">
        <div class="box">
          <el-table
            :data="twoData"
            tooltip-effect="dark"
            style="width: 100%; margin: 15px 0"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="name" label="培训主题" align="center">
            </el-table-column>
            <el-table-column prop="phone" label="培训时间" align="center">
            </el-table-column>
            <el-table-column prop="age" label="培训技能" align="center">
            </el-table-column>
            <!-- <el-table-column label='操作' align='center'>
              <template slot-scope='scope'>
                                <span
                                  class='spanBtn'
                                  @click='seeTrain(scope.row)'
                                >查看</span
                                >
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            align="center"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageTwo.pageSize"
            :current-page.sync="pageTwo.pageNo"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTwo.total"
            @size-change="handleTwoSize"
            @current-change="handleTwoChange"
          ></el-pagination>
        </div>
      </div>
      <div class="dialog_content" v-if="step == '3'">
        <div class="box">
          <el-table
            :data="threeData"
            tooltip-effect="dark"
            style="width: 100%; margin: 15px 0"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="name" label="时间" align="center">
            </el-table-column>
            <el-table-column prop="phone" label="来源" align="center">
            </el-table-column>
            <el-table-column prop="age" label="积分" align="center">
            </el-table-column>
            <!-- <el-table-column label='操作' align='center'>
              <template slot-scope='scope'>
                                <span
                                  class='spanBtn'
                                  @click='seeScore(scope.row)'
                                >查看</span
                                >
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            align="center"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageThree.pageSize"
            :current-page.sync="pageThree.pageNo"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageThree.total"
            @size-change="handleThreeSize"
            @current-change="handleThreeChange"
          ></el-pagination>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer dialog-footer-btn"
        v-if="openData.title != '详情'"
      >
        <el-button type="primary" @click="handleSubmit">确 定 </el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="定位信息"
      :visible.sync="showMap"
      width="50%"
      append-to-body
    >
      <el-form>
        <el-form-item label="显示位置：">
          <el-row>
            <el-col :span="4">
              <el-form-item>
                <el-select
                  v-model="formData.provinceId"
                  placeholder="请选择省"
                  @change="handleProvince"
                  :disabled="
                    normalInfo.orgLevel == 1 ||
                    normalInfo.orgLevel == 2 ||
                    normalInfo.orgLevel == 3 ||
                    normalInfo.orgLevel == 4 ||
                    normalInfo.orgLevel == 5 ||
                    openData.title == '详情'
                  "
                  style="width: 100%"
                  ref="selectShengChange"
                >
                  <el-option
                    v-for="(item, index) in provinceList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-select
                v-model="formData.cityId"
                placeholder="请选择市"
                :disabled="
                  normalInfo.orgLevel == 2 ||
                  normalInfo.orgLevel == 3 ||
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5 ||
                  openData.title == '详情'
                "
                @change="handleCity"
                ref="selectShiChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-select
                v-model="formData.zoneId"
                placeholder="请选择区"
                @change="handleArea"
                :disabled="
                  normalInfo.orgLevel == 3 ||
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5 ||
                  openData.title == '详情'
                "
                ref="selectQuChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="index"
                  :label="item.addName"
                  :value="item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-select
                v-model="formData.streetId"
                placeholder="请选择街道"
                :disabled="
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5 ||
                  openData.title == '详情'
                "
                @change="streetChange"
                ref="selectJiedaoChange"
              >
                <el-option
                  v-for="(item, index) in streetList"
                  :key="index"
                  :label="item.addName"
                  :value="item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-select
                v-model="formData.shequId"
                placeholder="请选择社区"
                :disabled="normalInfo.orgLevel == 5 || openData.title == '详情'"
                ref="selectShequChange"
                @change="handleCommunityChange"
              >
                <el-option
                  v-for="item in communityList"
                  :key="item.addCode"
                  :label="item.addName"
                  :value="+item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <input
            v-model.trim="formData.address"
            :disabled="openData.title == '详情'"
            id="tipinput"
            class="el-input__inner"
            :class="openData.title == '详情' ? 'innerCur' : ''"
            @focus="getMap('tipinput')"
            placeholder="请输入关键字"
            autocomplete="off"
          />
          <div class="map_container">
            <div
              class="map_right"
              id="container"
              style="width: 100%; height: 300px"
            ></div>
          </div>
        </el-form-item>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15px;
          "
        >
          <el-button
            @click="locationSend"
            type="primary"
            v-if="openData.title != '详情'"
            >确定
          </el-button>
          <el-button @click="locationClose" type="info">取消 </el-button>
        </div>
      </el-form>
    </el-dialog>
    <open-info
      :openData="openInfo"
      @canclePerson="cancleService"
      v-if="openState"
    ></open-info>
    <open-book
      :openData="bookInfo"
      @cancleOpen="cancleBook"
      v-if="bookState"
    ></open-book>
    <train-info
      :openData="trainInfo"
      @cancleOpen="cancleTrain"
      v-if="trainState"
    ></train-info>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
import openInfo from "./openInfo"
import openBook from "./openBook"
import trainInfo from "./trainInfo"
import exportVue from "@/utils/exportVue"
export default {
  props: ["openData"],
  components: { openInfo, openBook, trainInfo },
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    var checkIdCode = (rule, value, callback) => {
      let validateCard =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!validateCard.test(value)) {
        return callback(new Error("身份证号格式错误"))
      }
      callback()
    }
    return {
      normalInfo: {},
      showMap: false,
      oneData: [],
      twoData: [],
      threeData: [],
      step: 0,
      pageOne: { total: 0, pageSize: 10, pageNo: 1 },
      pageTwo: { total: 0, pageSize: 10, pageNo: 1 },
      pageThree: { total: 0, pageSize: 10, pageNo: 1 },
      bookState: false,
      trainState: false,
      trainInfo: {},
      bookInfo: {},
      openState: false,
      openInfo: {},
      quyuList: [],
      sexOptions: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      jobOptions: [
        {
          value: "1",
          label: "站长",
        },
        {
          value: "2",
          label: "副站长",
        },
        {
          value: "3",
          label: "普通员工",
        },
      ],
      baseURL: "",
      imageUrl: "",
      formData: {
        personName: "",
        personSex: "",
        personIdentity: "",
        personAge: "",
        personPhone: "",
        serviceStationId: "",
        serviceStationName: "",
        position: "",
        familyExperience: "",
        areaId: "",
        dataId: "",
        isWork: 1,
        personPhoto: "",
        provinceId: "", //省
        cityId: "", //市
        zoneId: "", //区
        streetId: "", //街道
        shequId: "", //社区
        address: "",
        longitude: "",
        latitude: "",
      },
      address: "",
      orgList: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      formDataRules: {
        //表格表单验证
        personName: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur",
          },
        ],
        personSex: [
          {
            required: true,
            message: "性别不能为空",
            trigger: "blur",
          },
        ],
        personIdentity: [
          {
            required: true,
            message: "身份证不能为空",
            trigger: "blur",
          },
          { validator: checkIdCode, trigger: "blur" },
        ],
        personAge: [
          {
            required: true,
            message: "年龄不能为空",
            trigger: "blur",
          },
        ],

        personPhone: [
          //手机
          {
            required: true,
            message: "手机号码不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],

        serviceStationName: [
          {
            required: true,
            message: "机构点不能为空",
            trigger: "blur",
          },
        ],
        position: [
          {
            required: true,
            message: "职位不能为空",
            trigger: "blur",
          },
        ],
        familyExperience: [
          {
            required: true,
            message: "家政经验不能为空",
            trigger: "blur",
          },
        ],
        dataId: [
          {
            required: true,
            message: "区域名称不能为空",
            trigger: "blur",
          },
        ],
        isWork: [
          {
            required: true,
            message: "是否工作人员不能为空",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "服务地址不能为空",
            trigger: "blur",
          },
        ],
        // personPhoto: [
        //     {
        //         required: true,
        //         message: "图片不能为空",
        //         trigger: "blur",
        //     },
        // ],
      },

      isMaps: false,
    }
  },
  created() {
    this.baseUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"

    this.formData = {
      personName: "",
      personSex: "",
      personIdentity: "",
      personAge: "",
      personPhone: "",
      serviceStationId: "",
      serviceStationName: "",
      position: "",
      familyExperience: "",
      certificateList: [],
      areaId: "",
      dataId: "",
      isWork: 1,
      personPhoto: "",
      provinceId: "", //省
      cityId: "", //市
      zoneId: "", //区
      streetId: "", //街道
      shequId: "", //社区
      address: "",
      longitude: "",
      latitude: "",
    }
    this.getProvince()
    if (this.openData.title == "新增") {
      // this.oneData = []
    } else {
      this.dataInfos()
    }
    //证书信息新增
    console.log(this.formData.id, "999")
    exportVue.$on("certificateForm", (data) => {
      if (this.comtitle == "新增") {
        if (this.oneData == null) {
          this.oneData = []
        }
        this.oneData.push(data)
      } else if (this.comtitle == "编辑") {
      }
      console.log(this.oneData, "this.oneData")
      this.$forceUpdate()
    })

    this.getJoin()
    this.getTree()
  },
  methods: {
    idCard(val) {
      if (parseInt(val.substr(16, 1)) % 2 == 1) {
        this.formData.personSex = "1"
        //是男则执行代码 ...
      } else {
        this.formData.personSex = "2"
        //是女则执行代码 ...
      }
      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.formData.personAge = age
    },
    // 获取组织树
    getTree() {
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            this.allList = res.content
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children,
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    changeOrg() {},
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }
      return childrenEach(treeData, depth)
    },
    // 获取组织机构
    getJoin() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            if (this.openData.title == "新增") {
              this.changeFirst()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        "机构信息 normalInfo.orgLevel",
        this.provinceList
      )
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getStreetList(this.normalInfo.cityId)
        this.areaList = areaList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getStreetList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        // this.areaList.forEach((item) => {
        //   if (item.adcode == this.normalInfo.areaId) {
        //     this.formData.latitude = item.center.lat
        //     this.formData.longitude = item.center.lng
        //   }
        // })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.formData.latitude = item.latitude
            this.formData.longitude = item.longitude
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.formData.provinceId = this.normalInfo.provinceId
      this.formData.cityId = this.normalInfo.cityId
      this.formData.zoneId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.shequId = this.normalInfo.communityId
      console.log(this.formData.longitude, this.formData.latitude, "获取")
      // this.potintMap()
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      var marker = new AMap.Marker({
        position: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
        map: this.myMap,
      })
      this.myMap.setFitView(marker)
    },
    // 地图打点
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.zoneId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    async streetChange(val) {
      this.formData.shequId = ""
      let communityList = await this.getStreetList(val)
      console.log(communityList, "社区列表")
      this.communityList = communityList
      this.joinAddress()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    mapTap() {
      this.showMap = true
      setTimeout(async () => {
        await this.$nextTick(() => {
          this.loadmap()
          this.potintMap()
        })
      }, 30)
    },
    // 取消查看培训
    cancleTrain() {
      this.trainState = false
      this.openInfo = false
      this.trainInfo = {}
    },
    // 查看积分
    seeScore(row) {},
    // 查看培训
    seeTrain(row) {
      this.trainState = true
    },
    addInfo(title, row) {
      this.bookState = true
      this.bookInfo = Object.assign(this.openData, {
        bookState: true,
        userId: this.formData.id,
        booTitle: title,
        cerdata: title == "新增" ? "" : row,
        ids: title == "新增" ? "" : row.id,
      })
      let comtitle = ""
      this.comtitle = title
      //     if(title !='新增'){
      //        console.log(row)
      //         let cerdata={}
      //          this.cerdata=row
      //          console.log(this.cerdata,'this.cerdata')
      //         exportVue.$emit("cerdata", this.cerdata)
      //    }
    },
    delInfo(date, index) {
      let cerindex = ""
      this.cerindex = index
      this.oneData.splice(index, 1)
      // let params = {
      //     id: date.id,
      // }
      // this.$confirm("确认永久删除吗?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      // }).then(() => {
      //     this.$http
      //         .request({
      //             url:
      //                 "/ypt/admin/serviceStaffCertificateinfo/deleteById",
      //             method: "POST",
      //             data: params,
      //         })
      //         .then((res) => {
      //             if (res.code === 200) {
      //                 this.$message.success(res.message)
      //                 // this.tableData = [];
      //                 this.getOneList()
      //             } else {
      //                 this.$message.error(res.message)
      //             }
      //         })
      // })
    },
    getTwoList() {},
    getThreeList() {},
    // 页面大小
    handleOneSize(val) {
      this.pageOne.pageSize = val
      this.getOneList()
    },
    // 当前页
    handleOneChange(val) {
      this.pageOne.pageNo = val
      this.getOneList()
    },
    // 页面大小
    handleTwoSize(val) {
      this.pageTwo.pageSize = val
      this.getTwoList()
    },
    // 当前页
    handleTwoChange(val) {
      this.pageTwo.pageNo = val
      this.getTwoList()
    },
    // 页面大小
    handleThreeSize(val) {
      this.pageThree.pageSize = val
      this.getThreeList()
    },
    // 当前页
    handleThreeChange(val) {
      this.pageThree.pageNo = val
      this.getThreeList()
    },
    // 步骤
    stepTap(num) {
      this.step = num
      if (this.openData.title != "新增") {
        if (num == 1) {
          this.getOneList()
        }
      } else {
        this.formData.id = this.formData.id
      }
    },
    // 证书列表获取
    getOneList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        servicePersonId: this.formData.id,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStaffCertificateinfo/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.oneData = []
              this.pageOne.total = 0
              return
            }
            this.oneData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    // 证书关闭
    cancleBook(data) {
      this.bookState = false
      if (data == true) {
      }
    },
    // 机构点
    cancleService(data) {
      this.openState = false
      if (data != false) {
        this.formData.dataId = data.dataId
        this.formData.areaId = data.areaId
        this.formData.serviceStationId = data.id
        this.formData.serviceStationName = data.statName
      }
    },
    // 查看机构点
    lookRY() {
      this.openState = true
      this.openInfo = Object.assign(this.openData, { openState: true })
    },
    // 详情页信息
    dataInfos() {
      const self = this
      let params = {
        id: self.openData.id,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStaff/info/getById",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            let jsonTemp = { ...res.content }
            self.formData.id = jsonTemp.id
            self.formData.personName = jsonTemp.personName
            self.formData.personSex = jsonTemp.personSex
            self.formData.personIdentity = jsonTemp.personIdentity
            self.formData.personAge = jsonTemp.personAge
            self.formData.personPhone = jsonTemp.personPhone
            self.formData.serviceStationId = jsonTemp.serviceStationId
            self.formData.dataId = jsonTemp.dataId.toString()
            self.formData.serviceStationName = jsonTemp.serviceStationName
            self.formData.position = String(jsonTemp.position)
            self.formData.familyExperience = jsonTemp.familyExperience
            self.formData.areaId = jsonTemp.areaId
            self.formData.areaName = jsonTemp.areaName
            self.formData.isWork = Number(jsonTemp.isWork)
            self.formData.personPhoto = jsonTemp.personPhoto
            self.formData.provinceId = String(jsonTemp.provinceId)
            self.formData.cityId = String(jsonTemp.cityId)
            self.formData.address = String(jsonTemp.address)
            self.formData.zoneId = String(jsonTemp.zoneId)
            self.formData.streetId = String(jsonTemp.streetId)
            self.formData.shequId = Number(jsonTemp.shequId)
            self.formData.longitude = jsonTemp.longitude
            self.formData.latitude = jsonTemp.latitude
            if (!self.formData.provinceId) return
            let city = await self.getDistrict(self.formData.provinceId)
            self.cityList = city.districtList
            if (!self.formData.cityId) return
            let area = await self.getStreetList(self.formData.cityId)
            self.areaList = area
            if (!self.formData.zoneId) return
            let street = await self.getStreetList(self.formData.zoneId)
            self.streetList = street
            if (!self.formData.streetId) return
            let communityList = await self.getStreetList(self.formData.streetId)
            self.communityList = communityList
            if (self.formData.latitude && self.formData.longitude) {
              this.potintMap()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //获取证书类型
    getCertificateTypeList() {
      this.$http
        .request({
          url: "/jjyl/admin/ststemdata/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
            type: "5",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.certificateTypeList = res.content.list || []
            //this.getCertificateNameList()
          }
        })
    },
    //表格表单提交
    handleSubmit() {
      let self = this
      if (this.openData.title == "新增" || this.openData.title == "编辑") {
        let url = ""

        if (!self.formData.provinceId) {
          self.$message.error("省级地址为必填项，请选择")
          return
        }
        if (!self.formData.cityId) {
          self.$message.error("市级地址为必填项，请选择")
          return
        }
        if (!self.formData.zoneId) {
          self.$message.error("区县级地址为必填项，请选择")
          return
        }
        if (!self.formData.streetId) {
          self.$message.error("街道地址为必填项，请选择")
          return
        }
        if (!self.formData.address) {
          self.$message.error("街道地址为必填项，请选择")
          return
        }
        if (
          self.formData.shequId === "" ||
          self.formData.shequId === null ||
          self.formData.shequId === undefined
        ) {
          self.$message.error(
            "社区为必填项，请选择,如无对应社区，请地址管理配置"
          )
          return
        }
        if (!self.formData.address) {
          self.$message.error(
            "详细信息为必填项，请在地图的边界内点击选择或手动输入"
          )
          return
        }
        delete this.formData.recTime
        self.formData.certificateList = self.oneData
        let data = { ...self.formData }
        // data.serviceType = data.serviceType.toString()
        // data.source = data.source.toString()
        if (this.openData.title == "新增") {
          url = "/ypt/admin/serviceStaff/info/insert"
        } else if (this.openData.title == "编辑") {
          url = "/ypt/admin/serviceStaff/info/modify"
        }

        this.$http
          .request({
            url: url,
            method: "POST",
            data: {
              ...data,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.$emit("cancleService", true)
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          })
      }
    },
    // 上传图片前的判断
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return isJPG
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!")
        return isLt2M
      }
    },
    //自定义图片上传
    handleAvatarSuccess(res, file, name) {
      this.$set(this.formData, "personPhoto", res.content)
    },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.longitude = lnglat.lng
            self.formData.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    locationClose() {
      this.showMap = false
    },
    //选择位置
    locationSend() {
      this.showMap = false
      // this.wCustomerInfo()
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            // if (bounds) {
            //     try {
            //         self.myMap.remove(self.polygons)
            //     } catch (error) {
            //         console.log("移除地图编辑出错了")
            //     }
            //     self.polygons = []
            //     for (let i = 0, l = bounds.length; i < l; i++) {
            //         self.polygon = new AMap.Polygon({
            //             map: self.myMap,
            //             strokeWeight: 1,
            //             strokeColor: "#0091ea",
            //             fillColor: "#80d8ff",
            //             fillOpacity: 0.4,
            //             path: bounds[i],
            //         })
            //         self.polygons.push(self.polygon)
            //         if (!params) {
            //             self.polygon.on("click", function (e) {
            //                 let lnglat = e.lnglat
            //                 self.myMap.add(self.marker)
            //                 self.marker.setPosition(lnglat)
            //                 geocoder.getAddress(
            //                     lnglat,
            //                     function (status, result) {
            //                         if (
            //                             status === "complete" &&
            //                             result.regeocode
            //                         ) {
            //                             var address =
            //                                 result.regeocode
            //                                     .formattedAddress
            //                             self.formData.address = address
            //                             self.formData.longitude =
            //                                 lnglat.lng
            //                             self.formData.latitude =
            //                                 lnglat.lat
            //                         } else {
            //                             console.error(
            //                                 "根据经纬度查询地址失败"
            //                             )
            //                         }
            //                     }
            //                 )
            //             })
            //             self.myMap.add(self.polygons)
            //             self.myMap.setFitView() //地图自适应
            //         } else {
            //             if (params.longitude && params.latitude) {
            //                 self.myMap.add(self.marker)
            //                 self.marker.setPosition([
            //                     params.longitude,
            //                     params.latitude,
            //                 ])
            //                 self.myMap.setFitView(self.marker)
            //                 self.myMap.setZoom(11)
            //             }
            //         }
            //     }
            // }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let area = await this.getStreetList(val)
      this.areaList = area
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    // 关闭人员信息
    dialogVisibleClone() {
      // this.openData.state=false;
      this.$emit("cancleService", false)
    },
  },
}
</script>
<style lang="less" scoped>
.avatar {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 180px;
  line-height: 180px;

  img {
    width: 180px;
    height: 180px;
    line-height: 180px;
    display: block;
  }
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 180px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 180px;
    line-height: 180px;
    text-align: center;
  }
}

.dialog-footer-btn {
  text-align: center;
}

.btnGroup {
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
  margin-bottom: 30px;
}

.spanBtn {
  cursor: pointer;
  margin-right: 10px;
}
</style>
